import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import almsgivingImage from '../assets/Gallery/2586E2BD-006C-4123-8BF3-005EDB651991.jpeg';

const ContactUs = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        contactNo: '',
        message: ''
    });

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [id]: value
        }));
    };

    const handleSubmit = () => {
        const { name, email, contactNo, message } = formData;
        const whatsappNumber = '+94771581869';
        const whatsappMessage = `Donation Inquiry:%0AName: ${name}%0AEmail: ${email}%0AContact No: ${contactNo}%0AMessage: ${message}`;
        const whatsappURL = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;
        window.open(whatsappURL, '_blank');
    };

    return (
        <div className="p-3 p-md-5 bg-light min-vh-100">
            <div className="container">
                {/* Contact Form Section */}
                <div className="mb-5 animate__animated animate__fadeIn">
                    <h2
                        className="text-center mb-4 fw-bold text-dark"
                        style={{
                            fontSize: 'calc(1.5rem + 1.5vw)',
                            letterSpacing: '1px',
                            borderBottom: '3px solid #458A44',
                            paddingBottom: '10px',
                            fontFamily: 'Georgia, serif',
                        }}
                    >
                        Donate to Us
                    </h2>
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-8">
                            <div className="card border-0 shadow-lg rounded-lg p-3 p-md-4" style={{ backgroundColor: '#fff' }}>
                                <div className="card-body">
                                    <div className="mb-3">
                                        <label htmlFor="name" className="form-label fw-bold text-dark">
                                            Name
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="name"
                                            placeholder="Enter your name"
                                            style={{ borderRadius: '8px', padding: '10px' }}
                                            value={formData.name}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="email" className="form-label fw-bold text-dark">
                                            Email
                                        </label>
                                        <input
                                            type="email"
                                            className="form-control"
                                            id="email"
                                            placeholder="Enter your email"
                                            style={{ borderRadius: '8px', padding: '10px' }}
                                            value={formData.email}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="contactNo" className="form-label fw-bold text-dark">
                                            Contact No.
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="contactNo"
                                            placeholder="Enter your contact number"
                                            style={{ borderRadius: '8px', padding: '10px' }}
                                            value={formData.contactNo}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="message" className="form-label fw-bold text-dark">
                                            Message
                                        </label>
                                        <textarea
                                            className="form-control"
                                            id="message"
                                            rows="5"
                                            placeholder="Enter your message"
                                            style={{ borderRadius: '8px', padding: '10px' }}
                                            value={formData.message}
                                            onChange={handleChange}
                                        ></textarea>
                                    </div>
                                    <div className="d-flex justify-content-center">
                                        <button
                                            type="button"
                                            className="btn btn-primary text-uppercase"
                                            style={{
                                                borderRadius: '8px',
                                                padding: '12px 24px',
                                                fontWeight: '500',
                                                backgroundColor: '#458A44',
                                                borderColor: '#458A44',
                                                transition: 'background-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease',
                                                width: '100%',
                                                maxWidth: '300px'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.backgroundColor = '#316CF4';
                                                e.target.style.borderColor = '#316CF4';
                                                e.target.style.transform = 'scale(1.05)';
                                                e.target.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.2)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.backgroundColor = '#458A44';
                                                e.target.style.borderColor = '#458A44';
                                                e.target.style.transform = 'scale(1)';
                                                e.target.style.boxShadow = 'none';
                                            }}
                                            onClick={handleSubmit}
                                        >
                                            Send Message
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Almsgiving Section */}
                <div className="mb-5 animate__animated animate__fadeIn">
                    <h2
                        className="text-center mb-4 fw-bold text-dark"
                        style={{
                            fontSize: 'calc(1.5rem + 1.5vw)',
                            letterSpacing: '1px',
                            borderBottom: '3px solid #458A44',
                            paddingBottom: '10px',
                            fontFamily: 'Georgia, serif',
                        }}
                    >
                        Almsgiving
                    </h2>
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-8">
                            <div className="card border-0 shadow-lg rounded-lg p-3 p-md-4" style={{ backgroundColor: '#fff' }}>
                                <div className="card-body text-center">
                                    <img
                                        src={almsgivingImage}
                                        alt="Almsgiving"
                                        className="img-fluid rounded"
                                        style={{ maxWidth: '100%', height: 'auto' }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Contact Details Section */}
                <div className="mb-5 animate__animated animate__fadeIn">
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-10 col-lg-6">
                            <div
                                className="card border-0 shadow-lg rounded-lg"
                                style={{
                                    backgroundColor: '#458A44',
                                    color: '#fff',
                                    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
                                }}
                            >
                                <div className="card-body p-3 p-md-4">
                                    <h3 className="fw-bold mb-3 text-center" style={{ fontSize: 'calc(1.2rem + 0.8vw)', fontFamily: 'Georgia' }}>
                                        Rev. Fr. Jude Chrishnan Perera
                                    </h3>
                                    <p className="mb-2" style={{ fontSize: '1rem', lineHeight: '1.6' }}>
                                        Mobile: (+94) 777 922 009 / (+94) 764 323 115 / (+94) 581 869
                                    </p>
                                    <p className="mb-2" style={{ fontSize: '1rem', lineHeight: '1.6' }}>
                                        Land: (+94) 342 223 363
                                    </p>
                                    <p className="mb-2" style={{ fontSize: '1rem', lineHeight: '1.6' }}>
                                        Email: marcsrihomes@gmail.com
                                    </p>
                                    <p className="mb-0" style={{ fontSize: '1rem', lineHeight: '1.6' }}>
                                        Facebook: MarcSri Homes
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Bank Details Section */}
                <div className="mb-5 animate__animated animate__fadeIn">
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-10 col-lg-6">
                            <div
                                className="card border-0 shadow-lg rounded-lg"
                                style={{
                                    backgroundColor: '#458A44',
                                    color: '#fff',
                                    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
                                }}
                            >
                                <div className="card-body p-3 p-md-4">
                                    <h3 className="fw-bold mb-3 text-center" style={{ fontSize: 'calc(1.2rem + 0.8vw)', fontFamily: 'Georgia' }}>
                                        Bank Details
                                    </h3>
                                    <p className="mb-2" style={{ fontSize: '1rem', lineHeight: '1.6' }}>
                                        Account Name: Archbishop of Colombo Marcsri Homes
                                    </p>
                                    <p className="mb-2" style={{ fontSize: '1rem', lineHeight: '1.6' }}>
                                        Account Number: 1000011362
                                    </p>
                                    <p className="mb-0" style={{ fontSize: '1rem', lineHeight: '1.6' }}>
                                        Bank: Commercial Bank, Kalutara
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Location Map Section */}
                <div className="mb-5 animate__animated animate__fadeIn">
                    <h2
                        className="text-center mb-4 fw-bold text-dark"
                        style={{
                            fontSize: 'calc(1.5rem + 1.5vw)',
                            letterSpacing: '1px',
                            borderBottom: '3px solid #458A44',
                            paddingBottom: '10px',
                            fontFamily: 'Georgia, serif',
                        }}
                    >
                        Our Location
                    </h2>
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="rounded-3 shadow-lg overflow-hidden" style={{ height: '50vh', minHeight: '300px', maxHeight: '500px' }}>
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4190.787395319932!2d79.96551947524127!3d6.559452893433717!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae2312b96f63581%3A0x530f9495c3fc5bfe!2sMarcsri%20Homes!5e1!3m2!1sen!2slk!4v1746113979340!5m2!1sen!2slk"
                                    width="100%"
                                    height="100%"
                                    style={{ border: 0 }}
                                    allowFullScreen=""
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                    title="Marcsri Homes Location"
                                ></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactUs;